import { AxiosInstance } from 'axios';
import { XdmEntityObject } from '../../models';

export const XDM_DATA_PAGE_SIZE = 1000;

export const getXdmEntityAllData = async (
  axios: AxiosInstance,
  entityName: string
): Promise<XdmEntityObject[]> => {
  let result: XdmEntityObject[] = [];
  let shouldFetch = true;

  do {
    const {
      data: { items, totalCount },
    } = await axios.get<{
      items: XdmEntityObject[];
      totalCount: number;
    }>(
      `${entityName}?Paging.Skip=${result.length}&Paging.Take=${XDM_DATA_PAGE_SIZE}`
    );

    result = [...result, ...items];
    shouldFetch = result.length < totalCount;
  } while (shouldFetch);

  return result;
};
